export const timeout = async (ms: number): Promise<unknown> =>
  await new Promise(resolve => setTimeout(resolve, ms));
